import request from '@/utils/request'

// 建账第一步
export function findPeople(data) {
  return request({
    url: 'api/v2/base/findPeople',
    method: 'post',
    data
  })
}

export function businessType(data) {
  return request({
    url: 'api/v2/base/businessType',
    method: 'post',
    data
  })
}

